<template>
  <div class="page container p-4 py-4">
    <section class="hero-intro text-center mb-4">
      <span class="section-eyebrow">Simples e rápido</span>
      <h2 class="mb-2 text-primary-emphasis">Como Funciona</h2>
      <p class="text-muted description-text mb-0">
        Em poucos minutos você cria sua lista, compartilha com quem ama e transfere os valores direto para sua conta.
      </p>
    </section>

    <section class="journey-strip mb-4">
      <p class="journey-strip__text mb-0">
        <i class="fas fa-sparkles me-2"></i>
        Fluxo pensado para ser intuitivo para você e simples para quem vai presentear.
      </p>
    </section>

    <section class="steps-grid mb-4">
      <div class="row g-3 justify-content-center">
        <div
          v-for="(step, index) in steps"
          :key="index"
          class="col-12 col-md-6 col-lg-3"
        >
          <article class="step-card h-100 text-center">
            <div class="step-chip mb-3">{{ step.kicker }}</div>
            <div class="step-icon-wrapper mx-auto mb-3">
              <i :class="step.icon" class="step-icon"></i>
            </div>
            <h3 class="h6 fw-bold mb-2">{{ step.title }}</h3>
            <p class="text-muted small mb-0">{{ step.text }}</p>
            <div v-if="index < steps.length - 1" class="step-arrow d-none d-lg-flex">
              <i class="fas fa-chevron-right"></i>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="benefits-box mb-4">
      <h3 class="h6 fw-bold mb-3">Por que usar a Presentei?</h3>
      <ul class="benefits-list mb-0">
        <li><i class="fas fa-check-circle me-2"></i>Cadastro da lista guiado e rápido</li>
        <li><i class="fas fa-check-circle me-2"></i>Pagamento fácil por Pix ou cartão para convidados</li>
        <li><i class="fas fa-check-circle me-2"></i>Transferência para sua conta com segurança</li>
      </ul>
    </section>

    <section class="cta-section text-center py-4">
      <h3 class="h5 fw-bold mb-3">Pronta para começar?</h3>
      <div v-if="!isLogged" class="d-flex flex-column flex-sm-row justify-content-center gap-2">
        <router-link to="/my-account/add" class="btn btn-primary btn-lg cta-btn-primary">
          <i class="fas fa-gift me-2"></i>Criar minha lista agora
        </router-link>
        <router-link to="/login" class="btn btn-outline-secondary btn-lg cta-btn-secondary">
          <i class="fas fa-right-to-bracket me-2"></i>Entrar
        </router-link>
      </div>
      <div v-else class="d-flex justify-content-center">
        <router-link to="/my-account/add" class="btn btn-primary btn-lg cta-btn-primary">
          <i class="fas fa-gift me-2"></i>Criar minha lista agora
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/authStore';

export default {
  name: 'HowItWorksPage',
  setup() {
    const authStore = useAuthStore();
    return {
      isLogged: computed(() => authStore.isAuthenticated),
    };
  },
  data() {
    return {
      steps: [
        {
          kicker: 'Comece',
          title: 'Crie sua lista',
          text: 'Escolha o tipo de evento, personalize sua página e selecione o que deseja receber.',
          icon: 'fa-solid fa-list-check',
        },
        {
          kicker: 'Compartilhe',
          title: 'Compartilhe com amigos',
          text: 'Envie o link da sua lista no WhatsApp, Instagram ou onde preferir.',
          icon: 'fa-solid fa-share-nodes',
        },
        {
          kicker: 'Receba',
          title: 'Seus convidados presenteiam',
          text: 'Cada presente pago vira valor para você acompanhar de forma organizada.',
          icon: 'fa-solid fa-gift',
        },
        {
          kicker: 'Finalize',
          title: 'Transfira para sua conta',
          text: 'Com sua chave Pix cadastrada, transfira o valor disponível direto para sua conta.',
          icon: 'fas fa-money-check-alt',
        },
      ]
    };
  }
};
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  height: auto;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
}

.section-eyebrow {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #ff50a3;
  margin-bottom: 0.4rem;
}

.text-primary-emphasis {
  color: #32355d !important;
  font-size: 1.9rem;
  font-weight: 700;
}

.description-text {
  font-size: 0.98rem;
  line-height: 1.5;
  max-width: 700px;
  margin: 0 auto;
}

.journey-strip {
  background: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 1rem;
  padding: 0.9rem 1rem;
}

.journey-strip__text {
  color: #666f87;
  font-size: 0.92rem;
  text-align: center;
}

.journey-strip__text i {
  color: #ff50a3;
}

.step-card {
  position: relative;
  background: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 1rem;
  padding: 1rem 1rem 1.1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.step-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff0f7;
  color: #d73084;
  border: 1px solid #ffd4e8;
  border-radius: 999px;
  padding: 0.18rem 0.65rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.step-icon-wrapper {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fb;
  border: 1px solid #eceef5;
}

.step-icon {
  color: #32355d;
  font-size: 1.5rem;
}

.step-arrow {
  position: absolute;
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #ececec;
  color: #b1b4c0;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  z-index: 2;
}

.benefits-box {
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 1rem;
  padding: 1rem;
}

.benefits-list {
  list-style: none;
  padding: 0;
}

.benefits-list li {
  color: #6c757d;
  font-size: 0.92rem;
  margin-bottom: 0.55rem;
}

.benefits-list li:last-child {
  margin-bottom: 0;
}

.benefits-list i {
  color: #ff50a3;
}

.cta-section {
  border-top: 1px solid #e9ecef;
}

.cta-btn-primary {
  background: linear-gradient(135deg, #ff50a3, #e6408f);
  border: none;
  color: #fff;
  font-weight: 700;
  border-radius: 2rem;
  padding: 0.75rem 1.6rem;
}

.cta-btn-primary:hover,
.cta-btn-primary:focus {
  background: linear-gradient(135deg, #e6408f, #c73580);
  color: #fff;
}

.cta-btn-secondary {
  border-radius: 2rem;
  padding: 0.75rem 1.6rem;
  font-weight: 600;
}

@media (max-width: 767.98px) {
  .page {
    margin-top: 0rem;
  }

  .text-primary-emphasis {
    font-size: 1.6rem;
  }

  .description-text {
    font-size: 0.92rem;
  }

  .journey-strip__text {
    font-size: 0.88rem;
  }
}
</style>